import { render, staticRenderFns } from "./DevelopmentalRoadmap.vue?vue&type=template&id=5c777ee6&scoped=true&"
import script from "./DevelopmentalRoadmap.vue?vue&type=script&lang=js&"
export * from "./DevelopmentalRoadmap.vue?vue&type=script&lang=js&"
import style0 from "./DevelopmentalRoadmap.vue?vue&type=style&index=0&id=5c777ee6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c777ee6",
  null
  
)

export default component.exports